import React from "react";
import { LoaderBackdrop, LoaderContainer, Overlay } from "components";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface LoadingOverlayProps {
    active: boolean;
    visible?: boolean;
    text?: string;
    height?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ active, visible = true, height, children }) => {
    const { t } = useTranslation();

    return (
        <Overlay height={height}>
            {active && visible && (
                <>
                    <LoaderBackdrop active={active} />
                    <LoaderContainer>
                        <CircularProgress />
                        <Typography component="div" variant="subtitle2">
                            <Box p={2}>{t("campaign.label.processing")}</Box>
                        </Typography>
                    </LoaderContainer>
                </>
            )}
            {children}
        </Overlay>
    );
};
